import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useInsuranceSubmissionStates() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.INSURANCE_SUBMISSION}/states/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
